import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Grid, Card, CardContent, Typography, Table, TableHead, TableRow, TableCell, TableBody, Button, Paper, MobileStepper } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import AutoPlaySwipeableViews from 'react-swipeable-views';
import AttendanceChart from './Dashboard/AttendanceChart'; // Import AttendanceChart
import { Birthdatecard } from "./BirthdateCard";
import moment from "moment";

const HOLIDAY_DATE_FORMATS = ["DD-MM-YYYY", "YYYY-MM-DD", "MM-DD-YYYY"];

const DragAndDropSections = ({
  sections,
  onDragEnd,
  classes,
  theme,
  permissions = [],
  active,
  activeStep,
  handleStepChange,
  handleNext,
  handleBack,
  maxStep,
  active1,
  activeStep1,
  handleStepChange1,
  handleNext1,
  handleBack1,
  maxStep1,
  pendingLeaves,
  approvedLeaves,
  handleLeaveClick,
  upcomingHolidays,
  timeEntries,
  userleave,
  handleTimeEntryClick,
  usersWithCurrentMonthDOJ,
  isSuperAdmin,
  pendingLeavesHeader,
  selectedMonth,
  selectedYear,
  statusColors // Add statusColors prop
}) => {
  const [expandedReasons, setExpandedReasons] = useState({});

  const toggleReasonExpansion = (index, event) => {
    event.stopPropagation();
    setExpandedReasons((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const permissionsArray = Array.isArray(permissions) ? permissions : [];

  const filteredSections = sections.filter(section => {
    if (section.id === 'Upcomingevent') return permissionsArray.includes("Dashboard.Upcomingevent") && active.length > 0;
    if (section.id === 'bfffday') return permissionsArray.includes("Dashboard.Birthday") && active1.length > 0;
    if (section.id === 'pendingLeaves') return pendingLeaves.length > 0 || approvedLeaves.length > 0;
    if (section.id === 'upcomingHolidays') return upcomingHolidays.length > 0;
    if (section.id === 'timeEntries') return isSuperAdmin && timeEntries && timeEntries.data && timeEntries.data.length > 0;
    if (section.id === 'userleave') return isSuperAdmin && userleave.length > 0;
    if (section.id === 'newJoinedEmployees') return isSuperAdmin && usersWithCurrentMonthDOJ.length > 0;
    if (section.id === 'attendanceChart') return isSuperAdmin;
    return false;
  });

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided) => (
          <Grid container spacing={2} style={{ paddingBottom: "100px" }} ref={provided.innerRef} {...provided.droppableProps}>
            {filteredSections.map((section, index) => (
              <Draggable key={section.id} draggableId={section.id} index={index}>
                {(provided, snapshot) => (
                  <Grid
                    item
                    xs={6}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      ...provided.draggableProps.style,
                      opacity: snapshot.isDragging ? 0.9 : 1,
                      boxShadow: snapshot.isDragging ? "0 10px 20px rgba(0,0,0,0.2)" : "none",
                      transition: "box-shadow 0.2s ease, opacity 0.2s ease",
                    }}
                  >

                    {section.id === 'Upcomingevent' && permissionsArray.includes("Dashboard.Upcomingevent") && active.length > 0 && (
                      <Card style={{ marginBottom: "3%", height: "95%" }} className={classes.upcomingCard}>
                        <div className={classes.pendingLeavesHeader}>
                          <Typography variant="h5" style={{ fontWeight: 600 }}>Upcoming Event</Typography>
                        </div>
                        <CardContent style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <Table className={classes.pendingLeavesTable}>
                            <TableHead>
                              <TableRow>

                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Name</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Date</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Event Details</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Image</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {active.map((event, index) => (
                                <TableRow key={index} className={index % 2 === 0 ? "zebra-table-row" : ""}>
                                  <TableCell className={classes.pendingLeavesTableCell}>{event.name}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{event.date}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{event.description}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    {event.image ? (
                                      <img
                                        src={event.image}
                                        alt={event.name}
                                        style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
                                      />
                                    ) : (
                                      <span>No Image</span>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    )}

                    {section.id === 'bfffday' && permissionsArray.includes("Dashboard.Birthday") && active1.length > 0 && (
                      <Card style={{ marginBottom: "3%", height: "95%", border: "solid rgb(165 163 163 / 87%) 1px" }} className={classes.upcomingCard}>
                        <div className={classes.pendingLeavesHeader}>
                          <Typography variant="h5" style={{ fontWeight: 600 }}>{active1.length} - Birthdays Today</Typography>
                        </div>
                        <CardContent style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
                          {/* Table hidden as per request */}
                          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', transform: 'scale(0.6)', transformOrigin: 'top center', height: '300px' }}>
                            <Birthdatecard
                              users={active1}
                              handleClose={() => { }}
                            />
                          </div>


                        </CardContent>
                      </Card>
                    )}

                    {section.id === 'pendingLeaves' && (pendingLeaves.length > 0 || approvedLeaves.length > 0) && (
                      <Card className={classes.pendingLeavesCard}>
                        <div className={classes.pendingLeavesHeader}>
                          <Typography variant="h5" style={{ fontWeight: 600 }}>{pendingLeavesHeader}</Typography>
                        </div>
                        <CardContent style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <Table className={classes.pendingLeavesTable}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Name</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Leave Type</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Date Range</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>No Of Days</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Reason For Leave</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {pendingLeaves.map((leave, index) => (
                                <TableRow key={index} onClick={() => handleLeaveClick(leave)} style={{ cursor: 'pointer' }} className={index % 2 === 0 ? "zebra-table-row" : ""}>
                                  <TableCell className={classes.pendingLeavesTableCell}>{leave.firstName}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{leave.leaveType}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    {(() => {
                                      const parts = leave.date_range ? leave.date_range.split(/\s+to\s+/i) : [];
                                      if (parts.length === 2) {
                                        return (
                                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span style={{ whiteSpace: 'nowrap' }}>{parts[0]}</span>
                                            <span style={{ fontSize: '0.85em', opacity: 0.8, margin: '2px 0' }}>To</span>
                                            <span style={{ whiteSpace: 'nowrap' }}>{parts[1]}</span>
                                          </div>
                                        );
                                      }
                                      return leave.date_range;
                                    })()}
                                  </TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{leave.no_of_days}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    {leave.ticket_mesasge ? (
                                      <>
                                        {expandedReasons[index] || leave.ticket_mesasge.length <= 50
                                          ? leave.ticket_mesasge
                                          : `${leave.ticket_mesasge.substring(0, 50)}...`}
                                        {leave.ticket_mesasge.length > 50 && (
                                          <span
                                            onClick={(event) => toggleReasonExpansion(index, event)}
                                            style={{ color: '#1b6e95', cursor: 'pointer', marginLeft: '5px', display: 'inline-block' }}
                                          >
                                            {expandedReasons[index] ? 'Read Less' : 'Read More'}
                                          </span>
                                        )}
                                      </>
                                    ) : 'N/A'}
                                  </TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    <div
                                      style={{
                                        display: 'inline-block',
                                        backgroundColor:
                                          leave.status === "Approved" ? "#16a34a" :
                                            leave.status === "Declined" || leave.status === "Rejected" ? "#e4aaaaff" :
                                              leave.status === "Cancelled" ? "#eab308" :
                                                leave.status === "Unapproved" ? "#e34d4d" :
                                                  "#e5e562ff",
                                        color: "#2a2a2a",
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                        fontFamily: 'Arial, sans-serif',
                                        minWidth: '70px',
                                        width: 'auto',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {leave.status}
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ))}
                              {approvedLeaves.map((leave, index) => (
                                <TableRow key={index} onClick={() => handleLeaveClick(leave)} style={{ cursor: 'pointer' }} className={index % 2 === 0 ? "zebra-table-row" : ""}>
                                  <TableCell className={classes.pendingLeavesTableCell}>{leave.firstName}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{leave.leaveType}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    {(() => {
                                      const parts = leave.date_range ? leave.date_range.split(/\s+to\s+/i) : [];
                                      if (parts.length === 2) {
                                        return (
                                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span style={{ whiteSpace: 'nowrap' }}>{parts[0]}</span>
                                            <span style={{ fontSize: '0.85em', opacity: 0.8, margin: '2px 0' }}>To</span>
                                            <span style={{ whiteSpace: 'nowrap' }}>{parts[1]}</span>
                                          </div>
                                        );
                                      }
                                      return leave.date_range;
                                    })()}
                                  </TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{leave.no_of_days}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    {leave.ticket_mesasge ? (
                                      <>
                                        {expandedReasons[index] || leave.ticket_mesasge.length <= 50
                                          ? leave.ticket_mesasge
                                          : `${leave.ticket_mesasge.substring(0, 50)}...`}
                                        {leave.ticket_mesasge.length > 50 && (
                                          <span
                                            onClick={(event) => toggleReasonExpansion(index, event)}
                                            style={{ color: '#1b6e95', cursor: 'pointer', marginLeft: '5px', display: 'inline-block' }}
                                          >
                                            {expandedReasons[index] ? 'Read Less' : 'Read More'}
                                          </span>
                                        )}
                                      </>
                                    ) : 'N/A'}
                                  </TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    <div
                                      style={{
                                        display: 'inline-block',
                                        backgroundColor:
                                          leave.status === "Approved" ? "#16a34a" :
                                            leave.status === "Declined" || leave.status === "Rejected" ? "#e4aaaaff" :
                                              leave.status === "Cancelled" ? "#eab308" :
                                                leave.status === "Unapproved" ? "#e34d4d" :
                                                  "#e5e562ff",
                                        color: "#2a2a2a",
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                        fontFamily: 'Arial, sans-serif',
                                        minWidth: '70px',
                                        width: 'auto',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {leave.status}
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    )}

                    {section.id === 'upcomingHolidays' && upcomingHolidays.length > 0 && (
                      <Card className={classes.holidayLeavesCard}>
                        <div className={classes.pendingLeavesHeader}>
                          <Typography variant="h5" style={{ fontWeight: 600 }}>Upcoming Holidays</Typography>
                        </div>
                        <CardContent style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <Table className={classes.pendingLeavesTable}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Holiday Name</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Date</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Total Days</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {upcomingHolidays.map((holiday, index) => {
                                const holidayDate = moment(holiday.date, HOLIDAY_DATE_FORMATS, true);
                                const formattedDate = holidayDate.isValid()
                                  ? `${holidayDate.format("DD-MM-YYYY")}, ${holidayDate.format("dddd")}`
                                  : holiday.date;

                                return (
                                  <TableRow key={index} className={index % 2 === 0 ? "zebra-table-row" : ""}>
                                    <TableCell className={classes.pendingLeavesTableCell}>{holiday.name}</TableCell>
                                    <TableCell className={classes.pendingLeavesTableCell}>
                                      {formattedDate}
                                    </TableCell>
                                    <TableCell className={classes.pendingLeavesTableCell}>{holiday.no_of_days}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    )}

                    {section.id === 'timeEntries' && isSuperAdmin && timeEntries && timeEntries.data && timeEntries.data.length > 0 && (
                      <Card className={classes.holidayLeavesCard} >
                        <div className={classes.pendingLeavesHeader}>
                          <Typography variant="h5" style={{ fontWeight: 600 }}>Time Entries</Typography>
                        </div>
                        <CardContent style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <Table className={classes.pendingLeavesTable}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Employee ID</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Name</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Date</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>In Time</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Out Time</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Durations</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {timeEntries.data.map((entry, index) => (
                                <TableRow key={index} onClick={() => handleTimeEntryClick(entry)} style={{ cursor: 'pointer' }} className={index % 2 === 0 ? "zebra-table-row" : ""}>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.name} </TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.Name}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.date}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.in_time}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.out_time}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.duration}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    <div
                                      style={{
                                        display: 'inline-block',
                                        backgroundColor:
                                          entry.is_approved === 0 ? "#16a34a" : // Approved (Green)
                                            entry.is_approved === 1 ? "#e5e562ff" : // Pending (Yellow)
                                              entry.is_approved === 2 ? "#e4aaaaff" : // Rejected (Red/Pink)
                                                "transparent",
                                        color: "#2a2a2a",
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                        fontFamily: 'Arial, sans-serif',
                                        minWidth: '70px',
                                        width: 'auto',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {entry.is_approved === 0 && 'Approved'}
                                      {entry.is_approved === 1 && 'Pending'}
                                      {entry.is_approved === 2 && 'Rejected'}
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    )}

                    {section.id === 'userleave' && isSuperAdmin && userleave.length > 0 && (
                      <Card className={classes.holidayLeavesCard} >
                        <div className={classes.pendingLeavesHeader}>
                          <Typography variant="h5" style={{ fontWeight: 600 }}>Users On-leave Today</Typography>
                        </div>
                        <CardContent style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <Table className={classes.pendingLeavesTable}>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Employee ID</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Name</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {userleave.map((entry, index) => (
                                <TableRow key={index} style={{ cursor: 'pointer' }} className={index % 2 === 0 ? "zebra-table-row" : ""}>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.empid} </TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{entry.name}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>
                                    <div
                                      style={{
                                        display: 'inline-block',
                                        backgroundColor: (() => {
                                          const status = entry.status ? entry.status.trim() : "";
                                          if (status === "On Leave") return "#ccff90";
                                          if (status === "Absent") return "#ff5c5c";
                                          if (status === "Present") return "#1dbb11";
                                          if (status === "Late" || status === "Comes Late") return "#9d744d";
                                          if (status === "Half day") return "#0acdb6";
                                          if (status === "Left Early") return "#065112";
                                          if (status === "Week Off") return "#0f38db";
                                          if (status === "Holiday") return "#ca04cd";

                                          // Fallback to API colors, avoiding white
                                          const apiColor = statusColors && statusColors[status];
                                          if (apiColor && apiColor !== '#ffffff' && apiColor !== '#fff' && apiColor !== 'white') {
                                            return apiColor;
                                          }
                                          return "transparent";
                                        })(),
                                        color: "black",
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                        fontFamily: 'Arial, sans-serif',
                                        minWidth: '70px',
                                        width: 'auto',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {entry.status}
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    )}

                    {section.id === 'newJoinedEmployees' && isSuperAdmin && usersWithCurrentMonthDOJ.length > 0 && (
                      <Card className={classes.newJoined}>
                        <div className={classes.pendingLeavesHeader}>
                          <Typography variant="h5" style={{ fontWeight: 600 }}>New Joined Employees Of This Month</Typography>
                        </div>
                        <CardContent style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Employee ID</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Name</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Birthday</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Date Of Join</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Designation</TableCell>
                                <TableCell className={classes.pendingLeavesTableHeaderCell}>Gender</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {usersWithCurrentMonthDOJ.map((user, index) => (
                                <TableRow key={index} className={index % 2 === 0 ? "zebra-table-row" : ""}>
                                  <TableCell className={classes.pendingLeavesTableCell}>{user.name}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{user.firstName}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{user.dob}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{user.doj}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{user.designation}</TableCell>
                                  <TableCell className={classes.pendingLeavesTableCell}>{user.gender}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                      </Card>
                    )}

                    {section.id === 'attendanceChart' && isSuperAdmin && (
                      <AttendanceChart selectedMonth={selectedMonth} selectedYear={selectedYear} />
                    )}

                  </Grid>
                )}
              </Draggable>
            ))
            }
            {provided.placeholder}
          </Grid >
        )}
      </Droppable >
    </DragDropContext >
  );
};

export default DragAndDropSections;
